import { J2Launchapp } from '@e3dc-react/icons'
import { IconButton } from '@e3dc-react/shell/Elements/Buttons/Buttons'
import { Typography } from '@e3dc-react/shell/Elements/Typography'
import { Box } from '@mui/material'
import React from 'react'

interface Props {
  marketReference: string
  title: string
  link: string
}

const ExternalDocumentLink: React.FC<Props> = ({ marketReference, title, link }) => {
  const handleExternalLinkClick = (): void => {
    window.open(link, '_blank', 'noopener,noreferrer')
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 2,
        padding: 2,
        border: '1px solid',
        borderColor: 'grey.grey06',
        backgroundColor: 'grey.grey07',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Typography>{getTitle(marketReference, title)}</Typography>
      <IconButton icon={<J2Launchapp />} onClick={handleExternalLinkClick} />
    </Box>
  )
}

export default ExternalDocumentLink

//#region getTitle

const getTitle = (marketReference: string, title: string): string => {
  if (title && marketReference) return `${marketReference} ${title}`
  if (title) return title
  if (marketReference) return marketReference
  return ''
}

//#endregion getTitle
